import { render } from "./ReadingQuestion.vue?vue&type=template&id=133d2ef4&scoped=true&lang=true"
import script from "./ReadingQuestion.vue?vue&type=script&lang=js"
export * from "./ReadingQuestion.vue?vue&type=script&lang=js"

import "./ReadingQuestion.vue?vue&type=style&index=0&id=133d2ef4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133d2ef4"]])

export default __exports__